<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Viewing Sales Order
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
      </div>
      <div
        class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]"
      >
        <button
          class="text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none bg-[#2463EB] text-white"
          @click="switchTab('order')"
        >
          Transaction Information
        </button>
      </div>
      <div class="bg-white p-1 rounded-[4px] mt-[16px]">
        <div class="flex items-center gap-[16px] w-full">
          <p class="text-[20px] font-bold text-[#2463EB] leading-[20px]">
            Order # {{ transferDetails.referenceId }}
          </p>
          <span
            class="flex items-center gap-[4px] max-w-max w-full"
            :class="[
              'badge',
              {
                'badge-success': transferDetails.status == 'ACTIVE',
                'badge-danger': transferDetails.status == 'REVERSED',
              },
            ]"
          >
            <span
              class="w-[10px] h-[10px] rounded-[1px]"
              :style="{
                backgroundColor:
                  transferDetails.status == 'ACTIVE' ? '#16a249' : '#EF5253',
              }"
            ></span>
            <span class="text-[12px] font-normal leading-[16.94px]">{{
              transferDetails.status == "ACTIVE" ? "Completed" : "Reversed"
            }}</span>
          </span>
        </div>
        <div
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
        >
          <h2
            class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
          >
            Originating warehouse
          </h2>
          <span
            class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
          >
            {{ transferDetails.origin.location.name }}</span
          >
        </div>
        <div
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
        >
          <h2
            class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
          >
            Transfer Date
          </h2>
          <span
            class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
          >
            {{ formatDate(transferDetails.createdAt) }}</span
          >
        </div>
        <div
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
        >
          <h2
            class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
          >
            Transfer By
          </h2>
          <span
            class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
          >
            {{ transferDetails.transferredBy.displayName }}</span
          >
        </div>
        <div
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
        >
          <h2
            class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
          >
            Stock Value
          </h2>
          <span
            class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
          >
            &#8358;{{ formatMoney(transferDetails.stockValue) }}</span
          >
        </div>
        <div
          class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
        >
          <h2
            class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
          >
            Total items
          </h2>
          <span
            v-for="(item, index) in transferDetails.products"
            :key="index"
            class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
          >
            {{ item.quantityTransfered }}</span
          >
        </div>
      </div>
      <div class="bg-white p-1 rounded-[4px] mt-[16px]">
        <div class="table-responsive">
          <table class="table text-nowrap">
            <thead class="bg-[#ECF9FF]">
              <tr>
                <th
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  Product
                </th>
                <th
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  Product Code
                </th>
                <th
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  Unit Price x QTY
                </th>
                <th
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  Stock Value
                </th>
                <th
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  Destination Warehouse
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr
                v-for="(item, index) in transferDetails.products"
                :key="index"
              >
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ item.product.name }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ item.product.code }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  &#8358;{{ formatMoney(item.product.retailPrice) }} X
                  {{ item.quantityTransfered }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  &#8358;{{
                    formatMoney(
                      item.product.retailPrice * item.quantityTransfered
                    )
                  }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ item.destinationInventory.subLocation.name }}
                </td>
              </tr>
              <tr v-if="!transferDetails.products.length">
                <td colspan="6">
                  <div class="text-center">No products available</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";

export default {
  isBusy: false,
  props: ["closeModal", "stockId", "transferDetails", "isBusy"],
  mixins: [SystemPermissions.Mixin],
  name: "settingsStockTransferCreate",

  data() {
    return {
      transferId: this.stockId,
      isBusyModal: false,
      order: {},
      sellerId: null,
      deliveryAddress: null,
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
  },
};
</script>
